import React from "react";
import { useSelector } from "react-redux";
import ReactPanZoom from "react-image-pan-zoom-rotate";
import LargeModal from "../../../../components/modals/LargeModal";
import { closePrescriptionModal } from "../../../../redux/actions/modals";
const PrescriptionZoomComponent = () => {
  const { show_prescription_open, show_prescription_url } = useSelector(
    (state) => state.modals
  );
  return (
    <LargeModal
      header="نمایش نسخه"
      show={show_prescription_open}
      closeFunction={closePrescriptionModal}
    >
      <div>
        <ReactPanZoom image={show_prescription_url} alt="document image" />
      </div>
    </LargeModal>
  );
};

export default PrescriptionZoomComponent;
